export default __webpack_public_path__ + "static/media/CMS_Meetings_Upload_Template.638f75b4.xlsx";